const ModalCharger_Icon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="26" height="26" rx="13" fill="#F2F8F6" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25 7.75C6.25 6.92157 6.92157 6.25 7.75 6.25H13.75C14.5785 6.25 15.25 6.92157 15.25 7.75V13H16C16.8285 13 17.5 13.6715 17.5 14.5V16.375C17.5 16.5821 17.6679 16.75 17.875 16.75C18.0821 16.75 18.25 16.5821 18.25 16.375V11.8106L17.3125 10.8732L17.2803 10.9053C16.9874 11.1982 16.5126 11.1982 16.2197 10.9053C15.9268 10.6124 15.9268 10.1376 16.2197 9.84467L16.2519 9.8125L16.2197 9.78033C15.9268 9.48743 15.9268 9.01257 16.2197 8.71967C16.5126 8.42678 16.9874 8.42678 17.2803 8.71967L19.3106 10.75C19.592 11.0313 19.75 11.4128 19.75 11.8106V16.375C19.75 17.4105 18.9105 18.25 17.875 18.25C16.8395 18.25 16 17.4105 16 16.375V14.5H15.25V18.25C15.6642 18.25 16 18.5858 16 19C16 19.4142 15.6642 19.75 15.25 19.75H6.25C5.83579 19.75 5.5 19.4142 5.5 19C5.5 18.5858 5.83579 18.25 6.25 18.25V7.75ZM11.4208 10.3354C11.6061 9.96493 11.4559 9.51442 11.0854 9.32918C10.7149 9.14393 10.2644 9.29411 10.0792 9.66459L8.58461 12.6537C8.33278 13.1573 8.69901 13.75 9.26214 13.75H11.0365L10.0792 15.6646C9.89393 16.0351 10.0441 16.4855 10.4146 16.6708C10.7851 16.856 11.2356 16.7059 11.4208 16.3354L12.9154 13.3463C13.1673 12.8426 12.801 12.25 12.2379 12.25H10.4635L11.4208 10.3354Z"
        fill="#79C8B0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25 7.75C6.25 6.92157 6.92157 6.25 7.75 6.25H13.75C14.5785 6.25 15.25 6.92157 15.25 7.75V13H16C16.8285 13 17.5 13.6715 17.5 14.5V16.375C17.5 16.5821 17.6679 16.75 17.875 16.75C18.0821 16.75 18.25 16.5821 18.25 16.375V11.8106L17.3125 10.8732L17.2803 10.9053C16.9874 11.1982 16.5126 11.1982 16.2197 10.9053C15.9268 10.6124 15.9268 10.1376 16.2197 9.84467L16.2519 9.8125L16.2197 9.78033C15.9268 9.48743 15.9268 9.01257 16.2197 8.71967C16.5126 8.42678 16.9874 8.42678 17.2803 8.71967L19.3106 10.75C19.592 11.0313 19.75 11.4128 19.75 11.8106V16.375C19.75 17.4105 18.9105 18.25 17.875 18.25C16.8395 18.25 16 17.4105 16 16.375V14.5H15.25V18.25C15.6642 18.25 16 18.5858 16 19C16 19.4142 15.6642 19.75 15.25 19.75H6.25C5.83579 19.75 5.5 19.4142 5.5 19C5.5 18.5858 5.83579 18.25 6.25 18.25V7.75ZM11.4208 10.3354C11.6061 9.96493 11.4559 9.51442 11.0854 9.32918C10.7149 9.14393 10.2644 9.29411 10.0792 9.66459L8.58461 12.6537C8.33278 13.1573 8.69901 13.75 9.26214 13.75H11.0365L10.0792 15.6646C9.89393 16.0351 10.0441 16.4855 10.4146 16.6708C10.7851 16.856 11.2356 16.7059 11.4208 16.3354L12.9154 13.3463C13.1673 12.8426 12.801 12.25 12.2379 12.25H10.4635L11.4208 10.3354Z"
        fill="url(#paint0_linear_417_9591)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_417_9591"
          x1="17.0781"
          y1="17.5"
          x2="9.22747"
          y2="9.64614"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C" />
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ModalCharger_Icon;
